export default {
  // Page Titles
  黑名单列表: "Blacklist",
  添加黑名单: "Add to Blacklist",
  供应商黑名单: "Supplier Blacklist",

  // Form Fields
  移入黑名单原因: "Reason for Adding to Blacklist",
  移出黑名单原因: "Reason for Removing from Blacklist",
  请输入移入黑名单原因: "Please enter the reason for adding to blacklist",
  请输入移出黑名单原因: "Please enter the reason for removing from blacklist",
  请输入: "Please enter",

  // Table Columns
  供应商名称: "Supplier Name",
  供应商名称中文: "Supplier Name (Chinese)",
  供应商名称英文: "Supplier Name (English)",

  // Action Buttons
  申请移出黑名单: "Apply for Removal from Blacklist",

  // Success Messages
  删除成功: "Deleted successfully",
  移入申请已提交: "Application to add to blacklist has been submitted",
  移出申请已提交: "Application to remove from blacklist has been submitted",
};
